<template>
  <b-card-code title="">
   
    <button
      @click="deleteDevices()"
      type="button"
      class="btn ml-auto btn-danger m-1 float-right"
    >
      Remove All Linked Devices
    </button>
    <button
      @click="downloadStaticCodes()"
      type="button"
      class="btn ml-auto btn-primary m-1 float-right"
    >
      Download Backup Codes
    </button>
    <h4>Enable 2FA</h4>
    <b-form-checkbox
      @change="giveWarningforMFA"
      v-model="is_2fa_enabled"
      :checked="is_2fa_enabled"
      name="check-button"
      switch
      inline
    >
      2FA enabled
    </b-form-checkbox>

    <div class="demo-inline-spacing" style="width:100%">
      <h4>What is 2FA?</h4>

      <p>
        2FA is an extra layer of security used to make sure that people trying
        to gain access to an online account are who they say they are. First, a
        user will enter their username and a password. Then, instead of
        immediately gaining access, they will be required to provide another
        piece of information.
      </p>
      <p>
        Valuementor uses a uses a software-generated time-based, one-time
        passcode (also called TOTP, or “soft-token”). First, a user must
        download and install a free 2FA app on their smartphone or desktop. They
        can then use the app with any site that supports this type of
        authentication. At sign-in, the user first enters a username and
        password, and then, when prompted, they enter the code shown on the app.
      </p>
      <h4>Add your device</h4>
      <p>
        Install a 2FA app such as Google Authenticator or Microsoft
        Authenticator on your device. Add CDR app by scanning the below QR Code.
        You are all set to use 2FA on your account.
      </p>

      <qrcode-vue :value="value" :size="size" level="H" />
    </div>
  <template>
    <b-sidebar
      id="sidebar-task-handler"
      sidebar-class="sidebar-lg"
      bg-variant="white"
      shadow
      backdrop
      no-header
      right
    >
      <!-- Header -->

      <BackupCodes
        :codes="codes"
        :closeSidebar="closeSidebar"
      />
    </b-sidebar>
  </template>
  </b-card-code>


</template>

<script>
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import { BFormCheckbox, BSidebar, VBToggle,} from "bootstrap-vue";
import QrcodeVue from "qrcode.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import BackupCodes from "./components/backup_codes.vue"
export default {
  components: {
    BCardCode,
    BFormCheckbox,
    QrcodeVue,
    BackupCodes,
    BSidebar,
    VBToggle,
  },
  directives: {
    "b-toggle": VBToggle,
  },
  data() {
    return {
      is_2fa_enabled: false,
      value: "",
      size: 300,
      codes: [],
    };
  },
  created: function () {
    this.getTotpSecret();
    this.getMFAStatus();
  },
  methods: {
    getTotpSecret: function () {
      const options = {
        method: "GET",
        headers: { "content-type": "application/json" },
        url: process.env.VUE_APP_BASEURL + "totp/create/",
      };
      this.$http(options).then((res) => {
        console.log(res);
        if (res.data) {
          this.value = res.data;
        }
      });
    },
    getMFAStatus: function () {
      const o_options = {
        method: "GET",
        url:
          process.env.VUE_APP_BASEURL +
          "user/users/" +
          this.$store.state.app.user.id +
          "/mfa-status",
      };
      this.$http(o_options).then((res) => {
        console.log(res);
        if (res.data) {
          this.is_2fa_enabled = Boolean(res.data.is_two_factor_enabled);
        }
      });
    },
    giveWarningforMFA:function(){
     if(this.is_2fa_enabled){
      if (
        confirm(
          "Please make sure you have add this account to your authentication app before you proceed. Enabling 2FA without any device linked will lock your account or you may not be able to login."
        )
      ) {
        this.setMFAStatus()
      }else{
        this.is_2fa_enabled = false
      }
     }
     else{
        this.setMFAStatus()
     }

    },
    setMFAStatus: function () {
      let data = {
        is_two_factor_enabled: this.is_2fa_enabled,
      };
      const o_options = {
        method: "POST",
        data: data,
        url:
          process.env.VUE_APP_BASEURL +
          "user/users/" +
          this.$store.state.app.user.id +
          "/mfa-set/",
      };
      this.$http(o_options).then((res) => {
        console.log(res);
        if (res.data) {
          this.is_2fa_enabled = Boolean(res.data.is_two_factor_enabled);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Successfully changed 2FA status",
              icon: "EditIcon",
              variant: "success",
            },
          });
        }
      });
    },
    deleteDevices: function () {
      if (
        confirm(
          "Do you really want to remove all linked devices and backup codes? This action can not be reversed. Do you want to proceed?"
        )
      ) {
        const doptions = {
          method: "POST",
          url: process.env.VUE_APP_BASEURL + "totp/delete/",
        };
        this.$http(doptions).then((res) => {
          console.log(res);
          if (res.data) {
            this.$toast({
                component: ToastificationContent,
                props: {
                title: "Successfully removed the devices",
                icon: "EditIcon",
                variant: "success",
                },
            });            
          }
        }).catch(err => {
            this.$toast({
                component: ToastificationContent,
                props: {
                title: "Error in removing the devices, please try again later",
                icon: "EditIcon",
                variant: "error",
                },
            });  
        })
      }
    },
    downloadStaticCodes: function(){
      const options = {
        method: "GET",
        headers: { "content-type": "application/json" },
        url: process.env.VUE_APP_BASEURL + "static/create/",
      };
      this.$http(options).then((res) => {
        console.log(res);
        if (res.data) {
            this.codes = res.data
            this.$root.$emit("bv::toggle::collapse", "sidebar-task-handler");
        //   this.value = res.data;
        }
      });        
    },
    closeSidebar: function () {
      this.$root.$emit("bv::toggle::collapse", "sidebar-task-handler");
    },
  },
};
</script>